import { ReactComponent as Magnet } from 'assets/svg/magnet.svg';

export default function NoRequest() {
    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="flex flex-col items-center justify-center gap-4">
                <Magnet />
                <h2 className="font-bold font-poppins text-lg text">No Client Requests Right Now!</h2>
                <p className="text-center text-gray-700 font-poppins  w-1/2">
                    It looks like all client requests are currently fulfilled or unavailable. Don’t worry—new opportunities are always around the corner! Check
                    back soon to explore fresh leads.
                </p>
            </div>
        </div>
    );
}
